import { FC } from 'react'

import { PetPolicyFieldKind } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { capitalizeEachFirstLetter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'
import { RadioBasedField } from './FiltersVariations/Radio'

interface PetPolicyFilterProps extends FiltersSharedProps {
  onChange: (value?: string) => void
  initialValue?: string
}

export const PetPolicyFilter: FC<PetPolicyFilterProps> = props => {
  const petPolicyOptions = Object.keys(PetPolicyFieldKind).map(petPolicy => {
    const value = PetPolicyFieldKind[petPolicy as keyof typeof PetPolicyFieldKind]
    return {
      value,
      title: capitalizeEachFirstLetter(value.replace(/_/g, ' ')),
      id: value,
    }
  })

  return (
    <RadioBasedField
      title="Pet Policy"
      radioGroupId="petPolicyFilterGroup"
      options={petPolicyOptions}
      {...props}
    />
  )
}
